module.exports = __webpack_public_path__ + "img/preview-program-image.bdffee4f.png";